import { Dispatch, SetStateAction } from "react";
import { SegmentNameUnion } from "pages/RequestIndex/hooks";

export type FilterDateValueTypes = "yesterday" | "today" | "tomorrow" | "custom" | undefined;

export type CustomDateValueType = {
  start?: string;
  end?: string;
};
export type LocalStorageFilterValueTypes = {
  dateOption?: FilterDateValueTypes;
  customDates?: CustomDateValueType;
  statuses: Array<SegmentNameUnion>;
  schools: Array<string>;
};

type ThreadedDataBase<T extends "active" | "past"> = {
  page: T;
  ls: LocalStorageFilterValueTypes;
  setLs: Dispatch<SetStateAction<LocalStorageFilterValueTypes>>;
};

export type ThreadedData = ThreadedDataBase<"active"> | ThreadedDataBase<"past">;

export const initialLocalStorageFilterValues: LocalStorageFilterValueTypes = {
  dateOption: undefined,
  statuses: [],
  customDates: { start: undefined, end: undefined },
  schools: [],
};
